export default __webpack_public_path__ + "static/media/cosmonaute-1.62b39feb.png";